import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, Inject, PLATFORM_ID } from "@angular/core";
import pkg from "../../../../package.json";
import { environment } from "../../../environments/environment";
import { Version, VersionService } from "../../services/version.service";

@Component({
  selector: "app-configuration",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./configuration.component.html",
  styleUrl: "./configuration.component.css",
})
export class ConfigurationComponent {
  readonly appVersion = pkg.version;
  readonly environment = environment;
  readonly hostname: string | null = null;
  readonly detectedVersion: Version | null = null;
  readonly modernAuthFlow: boolean = false;
  readonly devMode: boolean = false;
  readonly activeApiKey: string;
  readonly activeFallbackUrl: string | null = null;
  readonly activeGigyaApiDomain: string;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    versionService: VersionService,
  ) {
    this.detectedVersion = versionService.current;
    this.modernAuthFlow = versionService.modernAuthFlow;
    this.devMode = versionService.devMode;

    this.activeApiKey = this.detectedVersion === Version.NSGO
      ? environment.nsgoApiKey
      : environment.apiKey;

    switch (this.detectedVersion) {
      case Version.B2B: this.activeFallbackUrl = environment.fallbackUrlB2B; break;
      case Version.B2C: this.activeFallbackUrl = environment.fallbackUrlB2C; break;
      case Version.NSGO: this.activeFallbackUrl = environment.fallbackNsgo; break;
    }

    if (isPlatformBrowser(platformId)) {
      this.hostname = window.location.hostname;
    }

    this.activeGigyaApiDomain = this.detectedVersion === Version.NSGO
      ? environment.gigyaApiDomainNsgo
      : (this.hostname && environment.gigyaApiDomainsByHostname[this.hostname])
        || "https://cdns.gigya.com";
  }

  readonly gigyaApiDomainsByHostname = Object.entries(environment.gigyaApiDomainsByHostname);
}
